module.exports = __webpack_public_path__ + "img/success.fe04c2c0.png";